import React, { useEffect, useRef, useState } from 'react';
import '../App.css'; // Ensure CSS is imported

const ScrollAnimation = ({ children, variant = 'fade-up', className = '', delay = 0 }) => {
  const [isVisible, setIsVisible] = useState(false);
  const domRef = useRef();

  useEffect(() => {
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          setIsVisible(true);
          // Once visible, we can stop observing if we only want it to animate once
          observer.unobserve(entry.target); 
        }
      });
    }, {
      threshold: 0.1, // Trigger when 10% of the element is visible
      rootMargin: "0px 0px -50px 0px" // Slight offset to trigger a bit later than exact bottom
    });

    const currentElement = domRef.current;
    if (currentElement) {
      observer.observe(currentElement);
    }

    return () => {
      if (currentElement) {
        observer.unobserve(currentElement);
      }
    };
  }, []);

  const getDelayStyle = () => {
    return { transitionDelay: `${delay}ms` };
  };

  return (
    <div
      ref={domRef}
      className={`scroll-animate ${variant} ${isVisible ? 'visible' : ''} ${className}`}
      style={getDelayStyle()}
    >
      {children}
    </div>
  );
};

export default ScrollAnimation;
